<svg
  width="309"
  height="163"
  viewBox="0 0 309 163"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_572_325)">
    <path d="M0 163H309V0H0V163Z" fill="#FFE800" />
    <path
      d="M42.3247 47.9225L40.1683 47.9409L40.7128 111.581L42.8692 111.563L42.3247 47.9225Z"
      fill="black"
    />
    <path
      d="M47.7157 47.9196L45.5593 47.938L46.1038 111.578L48.2602 111.56L47.7157 47.9196Z"
      fill="black"
    />
    <path
      d="M57.6844 47.9122L52.8325 47.957L53.373 106.369L58.2249 106.325L57.6844 47.9122Z"
      fill="black"
    />
    <path
      d="M64.6927 47.9175L61.9972 47.9424L62.5377 106.355L65.2332 106.33L64.6927 47.9175Z"
      fill="black"
    />
    <path
      d="M72.7844 47.9129L69.0107 47.9478L69.5513 106.36L73.3249 106.325L72.7844 47.9129Z"
      fill="black"
    />
    <path
      d="M81.4099 47.9138L77.6362 47.9487L78.1768 106.361L81.9504 106.326L81.4099 47.9138Z"
      fill="black"
    />
    <path
      d="M85.9922 47.92L83.8358 47.9399L84.3763 106.352L86.5327 106.332L85.9922 47.92Z"
      fill="black"
    />
    <path
      d="M117.287 47.9215L115.13 47.9414L115.671 106.354L117.827 106.334L117.287 47.9215Z"
      fill="black"
    />
    <path
      d="M133.999 47.9234L131.842 47.9434L132.383 106.356L134.539 106.336L133.999 47.9234Z"
      fill="black"
    />
    <path
      d="M139.928 47.9224L137.772 47.9424L138.313 106.355L140.469 106.335L139.928 47.9224Z"
      fill="black"
    />
    <path
      d="M188.18 47.9236L186.563 47.936L187.103 118.205L188.72 118.193L188.18 47.9236Z"
      fill="black"
    />
    <path
      d="M209.205 47.9236L207.588 47.936L208.127 118.205L209.745 118.193L209.205 47.9236Z"
      fill="black"
    />
    <path
      d="M213.518 47.9231L211.9 47.9355L212.44 118.205L214.058 118.192L213.518 47.9231Z"
      fill="black"
    />
    <path
      d="M257.185 47.9275L255.568 47.9399L256.107 118.209L257.725 118.197L257.185 47.9275Z"
      fill="black"
    />
    <path
      d="M262.037 47.9226L260.42 47.9351L260.959 118.204L262.577 118.192L262.037 47.9226Z"
      fill="black"
    />
    <path
      d="M168.5 47.922L166.344 47.9419L166.885 106.354L169.041 106.334L168.5 47.922Z"
      fill="black"
    />
    <path
      d="M173.352 47.9205L171.196 47.9404L171.736 106.353L173.893 106.333L173.352 47.9205Z"
      fill="black"
    />
    <path
      d="M226.189 47.9171L224.032 47.937L224.573 106.349L226.729 106.329L226.189 47.9171Z"
      fill="black"
    />
    <path
      d="M242.901 47.9185L240.744 47.9385L241.285 106.351L243.441 106.331L242.901 47.9185Z"
      fill="black"
    />
    <path
      d="M248.292 47.9171L246.135 47.937L246.676 106.349L248.832 106.329L248.292 47.9171Z"
      fill="black"
    />
    <path
      d="M201.391 47.8982L194.921 47.958L195.462 106.37L201.931 106.311L201.391 47.8982Z"
      fill="black"
    />
    <path
      d="M221.876 47.9028L216.485 47.9526L217.026 106.365L222.417 106.315L221.876 47.9028Z"
      fill="black"
    />
    <path
      d="M235.353 47.9023L229.963 47.9521L230.503 106.364L235.894 106.315L235.353 47.9023Z"
      fill="black"
    />
    <path
      d="M126.451 47.9016L119.982 47.9614L120.523 106.374L126.992 106.314L126.451 47.9016Z"
      fill="black"
    />
    <path
      d="M97.5827 47.8935L89.4963 47.9683L90.0369 106.381L98.1233 106.306L97.5827 47.8935Z"
      fill="black"
    />
    <path
      d="M104.591 47.9097L99.7391 47.9546L100.28 106.367L105.132 106.322L104.591 47.9097Z"
      fill="black"
    />
    <path
      d="M113.216 47.9107L108.365 47.9556L108.905 106.368L113.757 106.323L113.216 47.9107Z"
      fill="black"
    />
    <path
      d="M150.953 47.9068L146.101 47.9517L146.642 106.364L151.493 106.319L150.953 47.9068Z"
      fill="black"
    />
    <path
      d="M161.196 47.9087L156.344 47.9536L156.884 106.366L161.736 106.321L161.196 47.9087Z"
      fill="black"
    />
    <path
      d="M181.953 47.9229L179.797 47.9395L180.337 118.209L182.493 118.192L181.953 47.9229Z"
      fill="black"
    />
    <path
      d="M44.4016 127.743V129.468H36.4819V128.46C36.4819 125.307 37.6356 124.046 40.2018 122.413C41.1938 121.788 42.6764 120.947 42.6764 119.627C42.6764 118.544 41.6844 117.611 40.6223 117.611C39.3231 117.611 37.7435 118.29 36.7191 119.039V117.008C37.7111 116.259 39.1182 115.892 40.3312 115.892C42.6225 115.892 44.5633 117.099 44.5633 119.557C44.5633 122.014 42.8058 122.909 41.0051 124.062C39.8137 124.849 38.3635 125.932 38.3635 127.468V127.743H44.3962H44.4016Z"
      fill="black"
    />
    <path
      d="M58.149 124.812V126.536H56.5155V129.468H54.6286V126.536H49.5717V124.558L53.4964 116.129H55.4372L51.4047 124.817H54.6286V122.068H56.5155V124.817H58.149V124.812Z"
      fill="black"
    />
    <path d="M62.4565 122.3H71.6593V124.186H62.4565V122.3Z" fill="black" />
    <path
      d="M76.6622 121.185V118.84L79.9077 116.129H81.9402V129.468H80.0533V118.253L76.6622 121.185Z"
      fill="black"
    />
    <path
      d="M89.8599 121.185V118.84L93.1053 116.129H95.1378V129.468H93.2509V118.253L89.8599 121.185Z"
      fill="black"
    />
    <path d="M102.049 122.3H111.252V124.186H102.049V122.3Z" fill="black" />
    <path
      d="M123.587 127.743V129.468H115.667V128.46C115.667 125.307 116.821 124.046 119.387 122.413C120.379 121.788 121.862 120.947 121.862 119.627C121.862 118.544 120.87 117.611 119.808 117.611C118.508 117.611 116.929 118.29 115.905 119.039V117.008C116.897 116.259 118.304 115.892 119.517 115.892C121.808 115.892 123.749 117.099 123.749 119.557C123.749 122.014 121.991 122.909 120.191 124.062C118.999 124.849 117.549 125.932 117.549 127.468V127.743H123.582H123.587Z"
      fill="black"
    />
    <path
      d="M136.801 117.994L133.447 121.346C135.739 121.454 137.334 122.942 137.334 125.302C137.334 128.272 134.86 129.624 132.186 129.624C130.957 129.624 129.857 129.312 128.741 128.837V126.951C129.787 127.63 130.941 127.905 132.148 127.905C133.836 127.905 135.448 127.172 135.448 125.248C135.448 123.47 134.057 122.791 132.439 122.791H130.973V121.341L134.402 117.843H128.741V116.119H136.806V117.989L136.801 117.994Z"
      fill="black"
    />
    <path
      d="M155.697 117.04H159.896C162.371 117.04 164.112 118.156 164.112 120.742C164.112 123.329 162.08 124.332 159.767 124.332H157.584V129.462H155.697V117.04ZM159.805 122.607C161.104 122.607 162.225 122.203 162.225 120.699C162.225 119.066 161.234 118.759 159.826 118.759H157.589V122.607H159.805Z"
      fill="black"
    />
    <path
      d="M176.393 117.994L173.04 121.346C175.331 121.454 176.927 122.942 176.927 125.302C176.927 128.272 174.453 129.624 171.779 129.624C170.549 129.624 169.45 129.312 168.334 128.837V126.951C169.38 127.63 170.533 127.905 171.741 127.905C173.428 127.905 175.04 127.172 175.04 125.248C175.04 123.47 173.649 122.791 172.032 122.791H170.566V121.341L173.994 117.843H168.334V116.119H176.399V117.989L176.393 117.994Z"
      fill="black"
    />
    <path
      d="M198.664 124.537V122.812H203.117V128.875C202.018 129.333 200.735 129.624 199.543 129.624C195.785 129.624 194.761 126.418 194.761 123.232C194.761 120.047 195.861 116.873 199.726 116.873C201.543 116.873 203.117 118.118 203.117 119.384V119.53H201.231C201.047 118.797 200.551 118.598 199.726 118.598C197.085 118.598 196.648 120.721 196.648 123.065C196.648 125.248 196.961 127.905 199.71 127.905C200.26 127.905 200.756 127.797 201.231 127.614V124.537H198.664Z"
      fill="black"
    />
    <path
      d="M223.113 117.04V125.173C223.113 126.913 223.534 127.905 225.421 127.905C227.308 127.905 227.728 126.913 227.728 125.173V117.04H229.615V125.302C229.615 127.997 228.316 129.624 225.415 129.624C222.515 129.624 221.216 127.991 221.216 125.302V117.04H223.102H223.113Z"
      fill="black"
    />
    <path
      d="M243.298 127.743V129.468H235.049V117.045H236.936V127.743H243.298Z"
      fill="black"
    />
    <path
      d="M256.495 127.743V129.468H248.247V117.045H250.134V127.743H256.495Z"
      fill="black"
    />
    <path
      d="M41.3664 29.6196H42.9352V40.948H41.0645L37.0211 32.3736H36.9888V40.948H35.4199V29.6196H37.4254L41.334 37.8383H41.3664V29.6196Z"
      fill="black"
    />
    <path
      d="M49.1351 40.948H47.4153V29.6196H50.7093C52.7795 29.6196 54.3699 30.6867 54.3699 32.9287C54.3699 34.3515 53.5828 35.6341 52.111 35.9036L55.0707 40.948H53.0976L50.5044 36.2539H49.1351V40.948ZM50.4074 34.6802C51.7929 34.6802 52.6447 34.3461 52.6447 32.8586C52.6447 31.3712 51.6096 31.1879 50.3858 31.1879H49.1297V34.6802H50.402H50.4074Z"
      fill="black"
    />
    <path
      d="M64.9636 29.6196H67.2063L61.7396 35.0143L67.5405 40.948H65.1684L60.3703 35.8659V40.948H58.6505V29.6196H60.3703V34.2491L64.969 29.6196H64.9636Z"
      fill="black"
    />
    <path
      d="M81.9403 40.948H80.2205V31.1879H77.1637V29.6196H85.0024V31.1879H81.9457V40.948H81.9403Z"
      fill="black"
    />
    <path
      d="M95.2618 29.6196H96.9816L93.8871 40.948H91.4988L88.442 29.6196H90.1618L92.701 39.245H92.7334L95.2564 29.6196H95.2618Z"
      fill="black"
    />
    <path
      d="M116.449 39.3745V40.9427H109.23V40.0212C109.23 37.1487 110.282 35.9953 112.621 34.5079C113.522 33.942 114.88 33.1713 114.88 31.9695C114.88 30.9833 113.98 30.1318 113.01 30.1318C111.823 30.1318 110.384 30.7515 109.451 31.436V29.5821C110.352 28.8976 111.64 28.5635 112.745 28.5635C114.837 28.5635 116.605 29.6683 116.605 31.9049C116.605 34.1414 114.999 34.9606 113.36 36.0169C112.271 36.7337 110.956 37.7199 110.956 39.1265V39.3798H116.455L116.449 39.3745Z"
      fill="black"
    />
    <path
      d="M128.585 36.7011V38.2694H127.097V40.9425H125.377V38.2694H120.762V36.464L124.342 28.7788H126.116L122.439 36.7011H125.382V34.1951H127.102V36.7011H128.59H128.585Z"
      fill="black"
    />
    <path d="M132.11 34.4111H140.505V36.1303H132.11V34.4111Z" fill="black" />
    <path
      d="M144.661 33.3921V31.2525L147.621 28.7788H149.475V40.9425H147.756V30.7136L144.661 33.3867V33.3921Z"
      fill="black"
    />
    <path
      d="M156.29 33.3921V31.2525L159.25 28.7788H161.104V40.9425H159.384V30.7136L156.29 33.3867V33.3921Z"
      fill="black"
    />
    <path d="M167.002 34.4111H175.391V36.1303H167.002V34.4111Z" fill="black" />
    <path
      d="M186.243 39.3745V40.9427H179.024V40.0212C179.024 37.1487 180.076 35.9953 182.415 34.5079C183.316 33.942 184.674 33.1713 184.674 31.9695C184.674 30.9833 183.774 30.1318 182.804 30.1318C181.618 30.1318 180.178 30.7515 179.245 31.436V29.5821C180.146 28.8976 181.434 28.5635 182.539 28.5635C184.631 28.5635 186.4 29.6683 186.4 31.9049C186.4 34.1414 184.793 34.9606 183.154 36.0169C182.07 36.7337 180.75 37.7199 180.75 39.1265V39.3798H186.249L186.243 39.3745Z"
      fill="black"
    />
    <path
      d="M197.888 30.4877L194.831 33.5434C196.923 33.6458 198.373 34.9986 198.373 37.1543C198.373 39.8597 196.114 41.0993 193.678 41.0993C192.556 41.0993 191.553 40.8136 190.535 40.3825V38.6633C191.489 39.2831 192.54 39.531 193.645 39.531C195.182 39.531 196.654 38.8627 196.654 37.1058C196.654 35.4836 195.381 34.8638 193.915 34.8638H192.578V33.5434L195.705 30.353H190.54V28.7847H197.893V30.4877H197.888Z"
      fill="black"
    />
    <path
      d="M218.197 39.3745V40.9427H210.978V40.0212C210.978 37.1487 212.029 35.9953 214.369 34.5079C215.269 33.942 216.628 33.1713 216.628 31.9695C216.628 30.9833 215.727 30.1318 214.757 30.1318C213.571 30.1318 212.131 30.7515 211.199 31.436V29.5821C212.099 28.8976 213.388 28.5635 214.493 28.5635C216.585 28.5635 218.353 29.6683 218.353 31.9049C218.353 34.1414 216.746 34.9606 215.107 36.0169C214.024 36.7337 212.703 37.7199 212.703 39.1265V39.3798H218.202L218.197 39.3745Z"
      fill="black"
    />
    <path
      d="M229.944 30.4012C230.397 31.7216 230.478 33.2737 230.478 34.6642C230.478 36.1516 230.397 39.2936 229.276 40.3607C228.672 40.9643 227.372 41.0936 226.418 41.0936C225.464 41.0936 224.159 40.9589 223.545 40.3607C222.44 39.2936 222.359 36.1516 222.359 34.6642C222.359 33.2791 222.44 31.7216 222.892 30.4012C223.458 28.7467 224.779 28.5635 226.418 28.5635C228.057 28.5635 229.378 28.7467 229.944 30.4012ZM224.262 31.4683C224.095 32.3899 224.078 33.8935 224.078 34.842C224.078 35.7259 224.111 38.4367 224.596 39.0673C224.914 39.5038 225.852 39.52 226.418 39.52C226.984 39.52 227.922 39.5038 228.24 39.0673C228.709 38.4313 228.758 35.7259 228.758 34.842C228.758 33.8881 228.726 32.3845 228.575 31.4683C228.359 30.1803 227.755 30.1318 226.418 30.1318C225.081 30.1318 224.477 30.1803 224.262 31.4683Z"
      fill="black"
    />
    <path d="M233.853 34.4111H242.241V36.1303H233.853V34.4111Z" fill="black" />
    <path
      d="M253.207 30.4012C253.66 31.7216 253.741 33.2737 253.741 34.6642C253.741 36.1516 253.654 39.2936 252.538 40.3607C251.935 40.9643 250.635 41.0936 249.681 41.0936C248.727 41.0936 247.422 40.9589 246.808 40.3607C245.702 39.2936 245.621 36.1516 245.621 34.6642C245.621 33.2791 245.708 31.7216 246.155 30.4012C246.721 28.7467 248.042 28.5635 249.681 28.5635C251.32 28.5635 252.641 28.7467 253.207 30.4012ZM247.525 31.4683C247.357 32.3899 247.341 33.8935 247.341 34.842C247.341 35.7259 247.374 38.4367 247.859 39.0673C248.177 39.5038 249.115 39.52 249.681 39.52C250.247 39.52 251.185 39.5038 251.503 39.0673C251.972 38.4313 252.021 35.7259 252.021 34.842C252.021 33.8881 251.988 32.3845 251.837 31.4683C251.622 30.1803 251.018 30.1318 249.681 30.1318C248.344 30.1318 247.74 30.1803 247.525 31.4683Z"
      fill="black"
    />
    <path
      d="M259.574 32.7076H259.973C262.48 32.7076 264.722 33.7963 264.722 36.5987C264.722 40.7108 259.957 41.0934 258.452 41.0934H257.886V39.5197H258.873C260.83 39.5197 263.003 38.8838 263.003 36.5772C263.003 34.4214 260.949 34.2059 259.962 34.2705L257.892 34.4214L258.258 28.7734H264.393V30.3417H259.779L259.579 32.6969L259.574 32.7076Z"
      fill="black"
    />
  </g>
  <defs>
    <clipPath id="clip0_572_325">
      <rect width="309" height="163" fill="white" />
    </clipPath>
  </defs>
</svg>
